@import '@hevoio/hevo-ui-toolkit/styles/variables';

.optionsContainer {
  display: flex;
  :not(:first-child) {
    margin-left: $spacer * 1.25;
  }
}

.optionButton {
  line-height: 16px;
  border-radius: $border-radius-default;
  border: transparent;
  background-color: $surface-bg-overlay;
  padding: $spacer * 0.5 $spacer * 0.5;
  color: $text-default;

  &:hover,
  &:focus {
    cursor: pointer;
    background-color: $menu-active-bg;
    color: $text-primary;
  }

  &.active {
    background-color: $primary !important;
    color: $light-text !important;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.popupBox {
  max-width: 180px !important;
}

.optionBadgeLabel {
  margin-top: -7px !important;
  margin-left: -$spacer !important;
  border: solid var(--border-width) var(--surface-bg-color);
}
